import React, { useState, useEffect, useCallback, useImperativeHandle, forwardRef } from 'react';

interface CounterProps {
  initialTime: number;
  onReset?: () => void;
}

const Counter = forwardRef(({ initialTime, onReset }: CounterProps, ref) => {
  const [timeLeft, setTimeLeft] = useState<number>(initialTime);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const resetTimer = useCallback(() => {
    setTimeLeft(initialTime);
    if (onReset) {
      onReset();
    }
  }, [initialTime, onReset]);

  useImperativeHandle(ref, () => ({
    resetTimer,
  }));

  return (
    <div className="w-full text-center pb-4 pt-2 text-sm">
      {timeLeft > 0 ? (
        <div className="text-blue-600">Verification code expires in: {formatTime(timeLeft)}</div>
      ) : (
        <div className="text-red-600">Verification code has expired.</div>
      )}
    </div>
  );
});

Counter.displayName = 'Counter';

export default Counter;